package com.essntl.features.profile.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.profile.data")
class ProfileModule
